export default {
  BOT_STATUS: {
    error:
      'An error retrieving the bots status happened, please try again in a few minutes.'
  },
  ETR: {
    dialog_activated: {
      title: 'Activating the Invoice Financing Bots',
      text: 'This proccess means that bots will run again and trades will be done automatically.',
      cta: 'Activate bots',
      action: 'activate_ETR_bot'
    },
    dialog_disabled: {
      title: 'Pausing the Invoice Financing Bots',
      text: 'This proccess means that automatic trades won’t happen until you activate them again. After pausing, you can do the manual trade.',
      cta: 'Pause bots',
      action: 'pause_ETR_bot'
    },
    notifications: {
      start_success: 'Invoice Financing bots successfully started',
      start_error: 'Error starting Invoice Financing bots',
      stop_success: 'Invoice Financing bots successfully stopped',
      stop_error: 'Error stopping Invoice Financing bots'
    }
  },
  ETP: {
    dialog_activated: {
      title: 'Activating the Payables Financing Bots',
      text: 'This proccess means that bots will run again and trades will be done automatically.',
      cta: 'Activate bots',
      action: 'activate_ETP_bot'
    },
    dialog_disabled: {
      title: 'Pausing the Payables Financing Bots',
      text: 'This proccess means that automatic trades won’t happen until you activate them again. After pausing, you can do the manual trade.',
      cta: 'Pause bots',
      action: 'pause_ETP_bot'
    },
    notifications: {
      start_success: 'Payables Financing bots successfully started',
      start_error: 'Error starting Payables Financing bots',
      stop_success: 'Payables Financing bots successfully stopped',
      stop_error: 'Error stopping Payables Financing bots'
    }
  }
}
